/**
 * @generated SignedSource<<9e2a14828127088d27eee602b3e82fc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
export type BuildArtifactsQuery$variables = {
  buildLocator: string;
};
export type BuildArtifactsQuery$data = {
  readonly build: {
    readonly artifacts: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly rawId: number | null | undefined;
    readonly state: BuildState | null | undefined;
  } | null | undefined;
};
export type BuildArtifactsQuery = {
  response: BuildArtifactsQuery$data;
  variables: BuildArtifactsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Files",
  "kind": "LinkedField",
  "name": "artifacts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildArtifactsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildArtifactsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3daddf501afdc49743be919e6f2654e",
    "id": null,
    "metadata": {},
    "name": "BuildArtifactsQuery",
    "operationKind": "query",
    "text": "query BuildArtifactsQuery(\n  $buildLocator: String!\n) {\n  build(buildLocator: $buildLocator) {\n    rawId\n    state\n    artifacts {\n      count\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bfef8035ce4505252c1abf5e63404d45";

export default node;
